import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetogoacabs() {



  const cardData = {




keyword: "Pune to Goa Cabs",

headingDescription: "Garud Cab Service provides comfortable and reliable Pune to Goa Cab Service for families, couples, friends, corporate groups, and travelers planning a convenient road journey to Goa. We offer chauffeur-driven Sedan, SUV, Ertiga, Kia Carens, Innova, Innova Crysta, Tempo Traveller, and premium vehicles for one-way trips, round trips, and customized Goa travel plans. With experienced drivers, clean and well-maintained cars, flexible pickup locations, spacious luggage facilities, transparent pricing, and 24/7 customer assistance, we make the journey from Pune to Goa smooth and convenient. Whether you are planning a family vacation, beach holiday, honeymoon, group tour, or extended Goa sightseeing trip, Garud Cab Service provides a comfortable and hassle-free travel experience.",

topPlaces: [
  {
    title: "Panaji",
    description: "Panaji is the capital city of Goa and an excellent destination for travelers interested in heritage, culture, riverside views, and Portuguese-influenced architecture. Visitors can explore the Mandovi waterfront, historic neighborhoods, churches, and local markets. Travelers booking a Pune to Goa cab can conveniently include Panaji in their Goa sightseeing itinerary."
  },
  {
    title: "Palolem Beach",
    description: "Palolem Beach is a beautiful South Goa destination known for its curved sandy shoreline, palm trees, calm atmosphere, and scenic Arabian Sea views. It is a popular choice for couples, families, and travelers looking for a relaxed beach experience. A private cab from Pune provides convenient access to Palolem with comfortable seating and luggage space."
  },
  {
    title: "Chapora Fort",
    description: "Chapora Fort is a historic hilltop fort in North Goa offering panoramic views of the Arabian Sea, Chapora River, and surrounding coastline. The fort is especially popular for sunset views and photography. Travelers can visit Chapora as part of a customized Goa tour while enjoying flexible transportation from Pune."
  },
  {
    title: "Baga Beach",
    description: "Baga Beach is one of North Goa's most popular tourist destinations, known for its lively atmosphere, water activities, beach restaurants, shopping, and entertainment. It is suitable for families, friends, and couples looking for an active beach experience. A chauffeur-driven Pune to Goa cab makes the long-distance journey comfortable and convenient."
  },
  {
    title: "Dudhsagar Waterfalls",
    description: "Dudhsagar Waterfalls is one of Goa's most famous natural attractions, surrounded by dense Western Ghats forests and dramatic rocky landscapes. The waterfall is particularly impressive during the monsoon season. Travelers from Pune can plan a Goa road trip and include the Dudhsagar region as part of a longer nature-focused itinerary."
  },
  {
    title: "Old Goa",
    description: "Old Goa is a major heritage destination featuring historic churches, basilicas, and monuments reflecting Goa's Portuguese-era history. The area is especially important for visitors interested in architecture, religion, and cultural heritage. Travelers arriving from Pune can conveniently explore Old Goa along with Panaji and nearby attractions."
  },
  {
    title: "Morjim Beach",
    description: "Morjim Beach is a peaceful North Goa destination known for its sandy coastline, relaxed atmosphere, palm trees, and beautiful sunsets. It offers a quieter alternative to some of the busier beaches in the region and is popular among couples and families. A private Pune to Goa cab allows travelers to reach Morjim directly with their luggage."
  },
  {
    title: "Colva Beach",
    description: "Colva Beach is one of South Goa's well-known beaches, featuring a long sandy shoreline, palm-lined surroundings, local food, and a relaxed coastal atmosphere. It is suitable for families, couples, and groups staying in South Goa. Travelers can book a spacious cab from Pune for comfortable long-distance travel and local sightseeing."
  },
  {
    title: "Fort Aguada",
    description: "Fort Aguada is a historic coastal fort and lighthouse complex overlooking the Arabian Sea near Candolim. Its massive laterite walls, sea views, and historic architecture make it one of Goa's important heritage attractions. Travelers can conveniently combine Fort Aguada with nearby beaches during a customized Goa sightseeing journey."
  },
  {
    title: "Ponda",
    description: "Ponda is an important cultural and religious region of Goa known for historic temples, lush greenery, spice plantations, and traditional Goan surroundings. It provides travelers with an opportunity to experience a different side of Goa beyond the beaches. A private cab makes it convenient to include Ponda in a flexible Pune to Goa travel itinerary."
  }
],



"services": [
{
"name": "Pune to Goa Cab Service",
"description": "Book Pune to Goa Cab Service for comfortable, reliable, and convenient long-distance transportation with professional chauffeurs and well-maintained AC vehicles. Choose from Swift Dzire, Sedan, Ertiga, Innova, Innova Crysta, Kia Carens, SUV, and premium cab options for family trips, business travel, holidays, sightseeing, one-way drops, and round-trip journeys with flexible pickup arrangements."
},
{
"name": "Pune to Goa Cab",
"description": "Reserve a Pune to Goa Cab for a smooth and private journey between Pune and Goa with experienced drivers, clean interiors, spacious seating, and dependable door-to-door transportation. Vehicle options are available for individuals, families, corporate travelers, tourists, and groups planning one-way travel, return journeys, weekend trips, beach holidays, or extended Goa vacations."
},
{
"name": "Pune to Goa Car Rental",
"description": "Hire Pune to Goa Car Rental with a professional chauffeur for comfortable and stress-free long-distance travel. Select an economical sedan, spacious Ertiga, comfortable Innova, premium Innova Crysta, Kia Carens, or SUV according to passenger count, luggage requirements, travel duration, and preferred level of comfort for family holidays, business trips, and tourist journeys."
},
{
"name": "Pune to Goa Taxi",
"description": "Choose Pune to Goa Taxi service for safe and comfortable road travel with courteous chauffeurs, air-conditioned vehicles, convenient pickup locations, and flexible journey options. The service is suitable for family vacations, beach holidays, corporate travel, tourist trips, personal visits, group travel, and passengers looking for private transportation from Pune to Goa."
},
{
"name": "Pune to Goa Taxi Fare",
"description": "Get transparent Pune to Goa Taxi Fare information with multiple vehicle choices designed for different budgets and travel requirements. Select a Swift Dzire, Sedan, Ertiga, Innova, Innova Crysta, Kia Carens, SUV, or premium cab according to passenger count, luggage capacity, travel duration, and whether you require one-way or round-trip transportation."
},
{
"name": "Pune to Goa Cab Package",
"description": "Book a Pune to Goa Cab Package for convenient holiday and outstation travel with a professional chauffeur and comfortable AC vehicle. Packages can be planned for family vacations, weekend trips, beach holidays, sightseeing, corporate travel, and customized Goa itineraries with suitable vehicle choices for individuals, families, and groups."
},
{
"name": "Pune to Goa Cab Fare",
"description": "Check Pune to Goa Cab Fare before booking and select a vehicle according to your budget, passenger capacity, luggage requirements, and travel preferences. Enjoy private chauffeur-driven transportation with options including Sedan, Swift Dzire, Ertiga, Innova, Innova Crysta, Kia Carens, and SUV for one-way, round-trip, family, corporate, and tourist journeys."
},
{
"name": "Best Cab Service from Pune to Goa",
"description": "Book the Best Cab Service from Pune to Goa for dependable long-distance transportation with experienced chauffeurs, clean AC vehicles, comfortable seating, convenient pickup, and flexible booking options. Sedan, Ertiga, Innova, Innova Crysta, Kia Carens, SUV, and premium vehicles are available for families, tourists, corporate travelers, couples, and groups."
},
{
"name": "Cab Service from Pune to Goa",
"description": "Choose Cab Service from Pune to Goa for a private and comfortable road journey with professional drivers, well-maintained AC vehicles, spacious seating, and convenient door-to-door transportation. The service is suitable for Goa vacations, beach trips, business travel, family journeys, sightseeing, weekend travel, and planned outstation transportation."
},
{
"name": "Car Hire Pune to Goa",
"description": "Hire a car from Pune to Goa with a professional chauffeur for convenient and relaxed long-distance travel. Select from Sedan, Ertiga, Innova, Innova Crysta, Kia Carens, SUV, and premium vehicles based on your group size, luggage requirements, travel schedule, and comfort preferences for family vacations, corporate travel, and tourist trips."
},
{
"name": "Car Rental Pune to Goa",
"description": "Reserve Car Rental Pune to Goa for comfortable chauffeur-driven transportation between Pune and Goa. Choose an economical sedan or spacious MUV, premium Innova Crysta, Kia Carens, or SUV according to your itinerary and passenger requirements while enjoying private AC travel, experienced drivers, convenient pickup, and direct destination drop."
},
{
"name": "Goa Pune Cab Service",
"description": "Choose Goa Pune Cab Service when planning a comfortable return journey from Goa to Pune with professional chauffeurs and well-maintained AC vehicles. The service provides private transportation for tourists, families, business travelers, and groups with suitable vehicle choices for airport transfers, hotel pickups, one-way travel, and round-trip requirements."
},
{
"name": "Goa to Pune Car Rental",
"description": "Book Goa to Pune Car Rental with a professional chauffeur for a convenient and comfortable return journey. Select from Sedan, Ertiga, Innova, Innova Crysta, Kia Carens, SUV, and premium cab options according to passenger count, luggage requirements, and travel preferences for business trips, family travel, tourist returns, and personal journeys."
},
{
"name": "One Way Cab from Pune to Goa",
"description": "Reserve One Way Cab from Pune to Goa for a direct point-to-point journey without arranging a return trip. Enjoy private AC transportation, professional chauffeur service, flexible pickup from your home, office, hotel, or other location, and suitable vehicle choices for solo travelers, families, corporate passengers, tourists, and groups."
},
{
"name": "Pune to Goa Cab Rental",
"description": "Hire Pune to Goa Cab Rental for convenient private transportation with experienced chauffeurs and comfortable AC vehicles. Choose a suitable Sedan, Ertiga, Innova, Innova Crysta, Kia Carens, SUV, or premium cab according to your passenger count, luggage needs, travel duration, and requirements for holidays, business trips, sightseeing, and outstation travel."
},
{
"name": "Pune to Goa Cab Cost",
"description": "Find a suitable Pune to Goa Cab Cost based on your selected vehicle, journey type, passenger requirements, and travel plan. Choose from economical sedans or spacious Ertiga, Innova, Innova Crysta, Kia Carens, and SUV vehicles while enjoying private chauffeur-driven transportation, comfortable AC interiors, convenient pickup, and direct destination drop."
},
{
"name": "Pune to Goa Cab Service Fare",
"description": "Get Pune to Goa Cab Service Fare details according to your selected vehicle and travel requirements. Flexible vehicle categories are available for solo travelers, families, corporate passengers, tourists, and groups, with options for one-way drops, return journeys, holiday trips, sightseeing, and customized travel plans."
},
{
"name": "Pune to Goa Cab Service Rates",
"description": "Compare Pune to Goa Cab Service Rates based on vehicle category, passenger capacity, luggage requirements, and selected journey type. Choose from Swift Dzire, Sedan, Ertiga, Innova, Innova Crysta, Kia Carens, SUV, and premium cabs for comfortable long-distance transportation with professional chauffeurs and flexible pickup arrangements."
},
{
"name": "Pune to Goa Car Booking",
"description": "Make Pune to Goa Car Booking for a scheduled private journey with convenient pickup and direct drop facilities. Select your preferred travel date, pickup location, passenger capacity, luggage requirements, and vehicle category while enjoying professional chauffeur service, clean AC interiors, and comfortable transportation for family holidays, business travel, and tourism."
},
{
"name": "Pune to Goa Car Hire",
"description": "Book Pune to Goa Car Hire with a professional chauffeur for a comfortable and private journey to Goa. Choose from Sedan, Ertiga, Innova, Innova Crysta, Kia Carens, SUV, and premium vehicles based on your group size and travel needs, making the service suitable for family vacations, corporate trips, weekend travel, and sightseeing."
},
{
"name": "Pune to Goa Car Rental Price",
"description": "Check Pune to Goa Car Rental Price according to the vehicle category, travel requirements, and selected journey plan. Choose economical sedans or spacious Ertiga, Innova, Innova Crysta, Kia Carens, and SUV options for comfortable chauffeur-driven transportation suitable for families, groups, tourists, corporate travelers, and personal trips."
},
{
"name": "Pune to Goa Innova Rental",
"description": "Hire Pune to Goa Innova Rental for spacious and comfortable family or group transportation with professional chauffeur service. The Innova offers comfortable seating, air conditioning, useful luggage capacity, and a practical option for long-distance journeys, family vacations, sightseeing trips, corporate travel, and one-way or round-trip Goa travel."
},
{
"name": "Pune to Goa One Way Cab",
"description": "Book Pune to Goa One Way Cab for a direct and convenient transfer from Pune to your preferred destination in Goa without arranging a return journey. Enjoy private AC transportation, experienced chauffeurs, flexible pickup locations, spacious luggage capacity, and suitable vehicle options for individuals, families, tourists, and groups."
},
{
"name": "Pune to Goa One Way Taxi",
"description": "Reserve Pune to Goa One Way Taxi for comfortable point-to-point transportation with no requirement for a return booking. Professional chauffeurs provide private AC travel with convenient pickup and direct drop facilities, making the service suitable for vacationers, business travelers, families, couples, tourists, and passengers traveling to North or South Goa."
},
{
"name": "Pune to Goa Private Cab",
"description": "Choose Pune to Goa Private Cab for a personalized and comfortable long-distance journey with an experienced chauffeur and exclusive vehicle. Enjoy convenient pickup, clean AC interiors, spacious seating, luggage-friendly arrangements, and vehicle choices suitable for family vacations, couples, corporate travelers, friends, and private Goa trips."
},
{
"name": "Pune to Goa Taxi Fare One Way",
"description": "Check Pune to Goa Taxi Fare One Way for a direct journey without including a return trip. Select a suitable Sedan, Ertiga, Innova, Innova Crysta, Kia Carens, SUV, or premium vehicle according to your budget, passenger count, luggage requirements, and comfort preferences while traveling with a professional chauffeur."
},
{
"name": "Pune to Goa Taxi Packages",
"description": "Book Pune to Goa Taxi Packages for customized holiday transportation with flexible travel options for one-way journeys, round trips, weekend vacations, family holidays, sightseeing, beach trips, and extended stays. Choose a comfortable vehicle and plan your journey according to your preferred schedule, passenger count, luggage, and Goa travel itinerary."
},
{
"name": "Pune to Goa Taxi Service",
"description": "Choose Pune to Goa Taxi Service for reliable and comfortable chauffeur-driven transportation with clean AC vehicles and convenient pickup arrangements. The service is suitable for families, couples, tourists, corporate travelers, friends, and groups planning Goa vacations, business trips, beach holidays, sightseeing, one-way transfers, or return journeys."
},
{
"name": "Pune to Goa Innova Crysta Cab",
"description": "Hire Pune to Goa Innova Crysta Cab for a premium and spacious long-distance journey with comfortable interiors, generous luggage space, air conditioning, and professional chauffeur service. It is a suitable choice for families, corporate travelers, groups, senior passengers, and customers looking for a refined and relaxed travel experience between Pune and Goa."
}
],
"tableData": [
["Pune to Goa Cab Service", "Pune to Goa Cab"],
["Pune to Goa Car Rental", "Pune to Goa Taxi"],
["Pune to Goa Taxi Fare", "Pune to Goa Cab Package"],
["Pune to Goa Cab Fare", "Best Cab Service from Pune to Goa"],
["Cab Service from Pune to Goa", "Car Hire Pune to Goa"],
["Car Rental Pune to Goa", "Goa Pune Cab Service"],
["Goa to Pune Car Rental", "One Way Cab from Pune to Goa"],
["Pune to Goa Cab Rental", "Pune to Goa Cab Cost"],
["Pune to Goa Cab Service Fare", "Pune to Goa Cab Service Rates"],
["Pune to Goa Car Booking", "Pune to Goa Car Hire"],
["Pune to Goa Car Rental Price", "Pune to Goa Innova Rental"],
["Pune to Goa One Way Cab", "Pune to Goa One Way Taxi"],
["Pune to Goa Private Cab", "Pune to Goa Taxi Fare One Way"],
["Pune to Goa Taxi Packages", "Pune to Goa Taxi Service"],
["Pune to Goa Innova Crysta Cab", ""]
],



whychoose: [
  {
    WhyChooseheading: "Pune to Goa Cabs for Flexible Holiday Travel",
    WhyChoosedescription: "Garud Cab Service offers private Pune to Goa cabs for travellers planning beach vacations, family holidays, group outings, resort stays, celebrations, and long-distance road trips with convenient pickup arrangements."
  },
  {
    WhyChooseheading: "Private Travel from Pune to Your Goa Destination",
    WhyChoosedescription: "Travel directly from your preferred Pune pickup point to your hotel, resort, villa, or other destination in Goa without needing to change vehicles during the journey."
  },
  {
    WhyChooseheading: "Choose Your Goa Travel Plan",
    WhyChoosedescription: "Whether you need a one-way drop or a return cab for your holiday, the trip can be arranged around your travel dates, accommodation plans, sightseeing schedule, and preferred departure time."
  },
  {
    WhyChooseheading: "Convenient for Families and Friend Groups",
    WhyChoosedescription: "Families and groups can choose a vehicle according to their passenger count and luggage requirements, creating a more convenient travel experience for a long road journey from Pune."
  },
  {
    WhyChooseheading: "Pickup from Home, Hotel or Office",
    WhyChoosedescription: "Garud Cab Service can arrange pickup from homes, hotels, offices, residential societies, or other preferred locations in Pune so you can begin your Goa trip from a convenient point."
  },
  {
    WhyChooseheading: "Suitable for North Goa & South Goa",
    WhyChoosedescription: "Plan transportation to your preferred destination across Goa, whether your holiday is focused on North Goa beaches, South Goa resorts, sightseeing, nightlife, or a peaceful coastal stay."
  },
  {
    WhyChooseheading: "Useful for Resorts, Events & Holidays",
    WhyChoosedescription: "Pune to Goa cabs can be used for resort transfers, family vacations, destination celebrations, corporate outings, college trips, weddings, and other planned journeys."
  },
  {
    WhyChooseheading: "Arrange Your Goa Cab with Garud",
    WhyChoosedescription: "Provide your Pune pickup location, Goa destination, travel date, passenger details, luggage requirement, and one-way or return preference to arrange a suitable cab for your trip."
  }
]


};


const faqData = [
  {
    question: "Does Garud Cab Service provide Pune to Goa Cabs?",
    answer: "Yes, Garud Cab Service provides Pune to Goa cab services for one-way travel, return trips, family holidays, group journeys, resort transfers, and sightseeing plans."
  },
  {
    question: "Can I book a one-way Pune to Goa cab?",
    answer: "Yes, one-way cabs are available for passengers who need direct transportation from Pune to their preferred destination in Goa."
  },
  {
    question: "Can I book a return cab for my Goa holiday?",
    answer: "Yes, round-trip cab arrangements can be planned according to your Goa stay, holiday dates, and preferred return schedule."
  },
  {
    question: "Can I get pickup from my Pune home?",
    answer: "Yes, pickup can be arranged from homes, hotels, offices, residential societies, and other convenient locations in Pune."
  },
  {
    question: "Can I travel directly to a Goa resort?",
    answer: "Yes, you can provide the name or location of your hotel, resort, villa, or other accommodation in Goa for direct transportation."
  },
  {
    question: "Can I book a cab to North Goa?",
    answer: "Yes, private cab transportation can be arranged from Pune to suitable destinations across North Goa according to your travel plan."
  },
  {
    question: "Can I book a cab to South Goa?",
    answer: "Yes, passengers travelling to South Goa can arrange a private cab from Pune based on their destination and travel schedule."
  },
  {
    question: "Is the service suitable for families?",
    answer: "Yes, families can choose a suitable vehicle based on passenger count, luggage, and comfort requirements for the long-distance journey."
  },
  {
    question: "Can groups travel together from Pune to Goa?",
    answer: "Yes, groups can select a suitable vehicle according to their number of passengers, luggage, and preferred travel comfort."
  },
  {
    question: "How can I book Pune to Goa Cabs?",
    answer: "Share your Pune pickup point, Goa destination, travel date, passenger count, preferred vehicle, and one-way or return requirement with Garud Cab Service to arrange your cab."
  }
];


const testimonials = [
  {
    id: 1,
    name: "Mr. Nikhil Bhandari",
    feedback: "Our group travelled from Pune to Goa for a holiday and chose a private cab. The direct journey was convenient and we had enough space for our bags throughout the trip.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Anjali More",
    feedback: "We booked a cab for our family Goa vacation and travelled directly to our resort. The pickup from Pune was convenient and the journey was comfortable for the whole family.",
    rating: 5
  }
];









  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Pune to Mumbai Airport Cab",
      link: "pune-to-mumbai-airport-cab-service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Pune to Outstation Cabs",
      link: "Pune-to-Outstation-Cabs",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Pune to Mahabaleshwar Cab",
      link: "pune-to-mahabaleshwar-cab-service",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Pune to Lonavala Cab",
      link: "pune-to-lonavala-cab-service",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Pune to Matheran Cabs",
      link: "pune-to-matheran-cab-service",
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Pune to 5 Jyotirlinga Darshan Cab",
      link: "pune-to-5-jyotirlinga-cab-service",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Pune to Bhimashankar Cab",
      link: "pune-to-bhimashankar-cab-service",
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Pune to Aurangabad Cab Service",
      link: "Pune-to-Aurangabad-Cab-Service",
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Pune to Nashik Cab Service",
      link: "Pune-to-Nashik-Cab-Service",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Pune to Kolhapur Cab Service",
      link: "Pune-to-Kolhapur-Cab-Service",
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Pune to Alibaug Cab",
      link: "Pune-to-Alibaug-Cab",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/13.jpg",
      text: "Goa to Pune Cabs",
      link: "Goa-to-Pune-Cabs",
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Innova Crysta Cab in Pune",
      link: "Innova-Crysta-Cab-in-Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Ertiga On Rent in Pune",
      link: "Ertiga-On-Rent-in-Pune",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Ashtavinayak Cabs",
      link: "pune-to-ashtavinayak-cab-service",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Goa Cabs",
      link: "Pune-to-Goa-Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Jyotirlinga Darshan Package",
      link: "Pune-to-Jyotirlinga-Darshan-Package",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Akkalkot Cabs",
      link: "Pune-to-Akkalkot-Cabs",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Pandharpur Cab",
      link: "Pune-to-Pandharpur-Cab",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Grishneshwar Jyotirlinga Cab",
      link: "Pune-to-Grishneshwar-Jyotirlinga-Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Mumbai Cabs",
      link: "pune-to-mumbai-cab-service",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Alibag Cab",
      link: "Pune-to-Alibag-Cab",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Innova Crysta On Rent in Pune",
      link: "Innova-Crysta-On-Rent-in-Pune",
    },

  ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Goa Cabs",
  "image": "https://garudcabs.com/assets/images/pune-to-goa-cabs.webp",
  "description": "Book Pune to Goa Cabs with Garud Cab for safe, comfortable, and convenient long-distance travel. Choose one way and round trip cab services, taxi, car rental, and Goa tour package options from Pune with Sedan, Ertiga, SUV, Innova, and Innova Crysta vehicles for family vacations, business travel, group journeys, and weekend getaways.",
  "brand": {
    "@type": "Brand",
    "name": "Garud Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7934"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://garudcabs.com/pune-to-goa-cabs"
  }
};





  return (
    <div>


<Helmet>
  <title>Pune to Goa Cabs | Taxi Fare, Car Rental & Package | +91 9970007784</title>

  <meta
    name="description"
    content="Book Pune to Goa Cabs with Garud Cab for comfortable and reliable travel. Get one way, round trip, taxi, car rental, and cab package options with competitive Pune to Goa fares and multiple vehicle choices."
  />

  <meta
    name="keywords"
    content="Pune to Goa cab service, Pune to Goa cab, Pune to Goa car rental, Pune to Goa taxi, Pune to Goa taxi fare, Pune to Goa cab package, Pune to Goa cab fare"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <section className="page-banner">
        <div className="page-banner-container">
          <h2>
            {cardData.keyword}
          </h2>
        </div>
      </section>








      <section>
        <div className="container-fluid p-0" >
          <div className="row container-fluid px-md-2">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/17.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Garud Cabs Services: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>





              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>



              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-dark">
                  Why Choose <span>Garud Cabs Services</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Garud Cabs Services </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919970007784 " className="pc-call">+91 9970007784 </a>
                    </div>
                    <div className="pc-list">
                      <a href="tel:+919970353709 " className="pc-call">+91 9970353709 </a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919970007784 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919970007784 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@garudcabs.com" className="pc-email">
                      booking@garudcabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Garud Cabs Services</strong><br />
                      Office No.101 Anand Heights
                      Chandan Nagar, Kharadi, Pune,
                      Maharashtra, India-  411014




                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetogoacabs;